import PropTypes from 'prop-types';
import { MemoryRouter, matchPath } from 'react-router';

export default class TrackableMemoryRouter extends MemoryRouter {
    static defaultProps = {
        onHistoryChanged: null,
        trackedParams: '',
    }

    static propTypes = {
        initialEntries: PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.shape({}),
            ]),
        ),
        initialIndex: PropTypes.number,
        getUserConfirmation: PropTypes.func,
        keyLength: PropTypes.number,
        children: PropTypes.node,
        onHistoryChanged: PropTypes.func,
        trackedParams: PropTypes.string,
    }

    constructor(props) {
        super(props);
        this.onHistoryChanged = this.onHistoryChanged.bind(this);
    }

    componentWillMount() {
        const onHistoryChanged = this.props.onHistoryChanged;
        if (onHistoryChanged) {
            this.unlistenRedux = this.history.listen(this.onHistoryChanged);
        }
    }

    onHistoryChanged() {
        const pathName = this.history.location.pathname;
        const result = matchPath(pathName, {
            path: this.props.trackedParams,
        });
        const params = !!result && result.params;
        this.props.onHistoryChanged(pathName, params);
    }

    componentWillUnmount() {
        const onHistoryChanged = this.props.onHistoryChanged;
        if (onHistoryChanged) {
            this.unlistenRedux();
        }
    }
}



// WEBPACK FOOTER //
// /src/js/common/transitionRouter/TrackableMemoryRouter.js